// extracted by mini-css-extract-plugin
export var active = "_cy-7";
export var container = "_cy-0";
export var evenWidth = "_cy-4";
export var large = "_cy-5";
export var outlet = "_cy-8";
export var slide = "_cy-2";
export var small = "_cy-6";
export var tab = "_cy-3";
export var tabs = "_cy-1";